






import { defineComponent, ref } from "@vue/composition-api";

/**
 * 头部导航
 */
export default defineComponent({
  setup() {
    const searchContent = ref<string>("");
    return { searchContent };
  },
});
